import React from "react";
import PropTypes from "prop-types";
import Image from "../../elements/image";
import "./style.scss";

const CarOrderItem = ({
  image,
  name,
  details,
}) => {
  return (
    <div className="car-order-item">
      <div className="car-order-item__image">
        <Image {...image} />
      </div>
      <div className="car-order-item__data">
        <span className="car-order-item__name">{name}</span>
        <ul className="car-order-item__details">
          {details.map((detail, index) => {
            return (
              <li key={index} className="car-order-item__details-item">
                {detail.label} {detail.value}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

CarOrderItem.propTypes = {
  image: PropTypes.shape(Image.propTypes).isRequired,
  name: PropTypes.string.isRequired,
  details: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ),
};

export default CarOrderItem;
